import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import Industries from './components/industries';
import Benefits from './components/benefits';
import UseCaseBanner from './components/usecaseBanner';
import Usecase from './components/usecase';



const RoboticsUseCase = () => {


    return(<>
    <WebsiteLayout>
     <UseCaseBanner/>
     <Industries/>
     <Usecase/>
     <Benefits/>
    </WebsiteLayout>
    </>);


}

export default RoboticsUseCase;